import { startCase } from 'lodash';

import {
  CheckMetadata,
  CheckMetadataItemType,
  GroupedCheckMetadataItem,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdMrzInconsistencyDetection } from 'dashboard/models/check';

export const computeIdMrzInconsistencyDetectionMetadata = (
  check: IdMrzInconsistencyDetection,
): CheckMetadata => {
  const invalidFields = check.metadata?.['mrz-invalid-fields'] ?? [];

  const metadata = invalidFields.map((invalidField: { [x: string]: string }) => {
    return {
      type: CheckMetadataItemType.Group,
      heading: {
        title: startCase(invalidField['field']),
      },
      items: [
        {
          label: 'Parsed Value',
          value: invalidField['parsed-value'],
        },
        {
          label: 'Calculated Checksum',
          value: invalidField['calculated-checksum'],
        },
        {
          label: 'Parsed Checksum',
          value: invalidField['parsed-checksum'],
        },
      ],
    } as GroupedCheckMetadataItem;
  });

  return {
    metadata: metadata,
    hideIfVerificationPassed: false,
  };
};
